import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Btn } from "../components/ui-kit";
import { api } from "../lib/api";

export default function GivePaypalReturn() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("processing");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const type = params.get("type");
    const run = async () => {
      try {
        if (type === "subscription") {
          const subId = params.get("subscription_id");
          if (!subId) return setStatus("error");
          const { data } = await api.get(`/paypal/subscription/${subId}`);
          setInfo(data.record); setStatus(data.active ? "recurring" : "error");
        } else {
          const orderId = params.get("token");
          if (!orderId) return setStatus("error");
          const { data } = await api.post(`/paypal/order/${orderId}/capture`);
          setInfo(data.record); setStatus(data.paid ? "paid" : "error");
        }
      } catch { setStatus("error"); }
    };
    run();
  }, [params]);

  return (
    <div className="min-h-screen grid place-items-center bg-white pt-[72px] px-5" data-testid="paypal-return-page">
      <div className="text-center max-w-md">
        {status === "processing" && <><Loader2 className="animate-spin mx-auto text-[#E63946] mb-6" size={48} /><h1 className="font-display font-bold text-3xl">Confirming your gift…</h1></>}
        {status === "paid" && (info?.kind === "ticket" ? (
          <><CheckCircle2 className="mx-auto text-[#E63946] mb-6" size={56} /><h1 className="font-display font-extrabold text-4xl mb-4">You're going!</h1><p className="text-black/60 text-lg mb-8">Your purchase of <span className="font-bold text-black">{info?.quantity} ticket(s)</span> to <span className="font-bold text-black">{info?.event_title}</span> is confirmed (${info?.amount}). A confirmation will be sent to your email. We can't wait to celebrate with you!</p><Btn to="/events" testid="pp-events">Back to Events</Btn></>
        ) : (
          <><CheckCircle2 className="mx-auto text-[#E63946] mb-6" size={56} /><h1 className="font-display font-extrabold text-4xl mb-4">Thank you!</h1><p className="text-black/60 text-lg mb-8">Your generous gift of <span className="font-bold text-black">${info?.amount}</span> to {info?.fund} has been received. God bless you!</p><Btn to="/" testid="pp-home">Back to Home</Btn></>
        ))}
        {status === "recurring" && <><CheckCircle2 className="mx-auto text-[#E63946] mb-6" size={56} /><h1 className="font-display font-extrabold text-4xl mb-4">You're all set!</h1><p className="text-black/60 text-lg mb-8">Your <span className="font-bold text-black">{info?.frequency}</span> gift of <span className="font-bold text-black">${info?.amount}</span> to {info?.fund} is now active. Thank you for your faithful generosity!</p><Btn to="/" testid="pp-home">Back to Home</Btn></>}
        {status === "error" && <><XCircle className="mx-auto text-black/40 mb-6" size={56} /><h1 className="font-display font-bold text-2xl mb-3">Payment not completed</h1><p className="text-black/60 mb-6">We couldn't confirm your gift. Please try again or contact us.</p><Btn to="/give" testid="pp-retry">Return to Giving</Btn></>}
      </div>
    </div>
  );
}
